<template>
  <div id="tabMain" class="container root">
    <div class="row">
      <div class="col p-0">
        <div class="nav-wrap">
          <nav ref="tabNav" class="nav nav-tabs nav-fill" @scroll="updateScrollIndicator">
          <a
            v-for="(item, index) in tabs"
            :key="index"
            :id="item.route"
            :class="'nav-item nav-link ' + active(item.route)"
            v-on:click="setActive(item.route)"
            >{{ item.name }}</a
          >
          </nav>
          <div v-if="showRightIndicator" class="nav-more-indicator">
            <i class="icon-right-open"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPassedConditions } from '@/helper/uiConfig'

export default {
  name: 'tabMain',
  data() {
    return {
      showRightIndicator: false,
    }
  },
  computed: {
    saleType() {
      const { user_data } = this.$store.state
      const customerSaleType = user_data?.customerSaleType
      return customerSaleType ? customerSaleType.toLowerCase() : ''
    },
    tabs() {
      // const pathName = this.$route.name
      // const { saleType } = this
      let tabList = [
        {
          name: 'แลกคะแนน',
          route: 'rewards',
        },
        {
          name: 'คะแนน',
          route: 'invoices',
        },
        {
          name: 'ประวัติ',
          route: 'history',
        },
        // {
        //   name: 'ลุ้นรางวัล',
        //   route: 'lucky-draws',
        // },
        // {
        //   name: 'คูปอง',
        //   route: 'my-coupon',
        // },
        // {
        //   name: 'แชะ&โชว์',
        //   route: 'ai-shelf',
        // },
        // {
        //   name: "ลุ้นรางวัล",
        //   route: "lucky-draws-campaign",
        // },
        // {
        //   name: 'คำนวณ',
        //   route: 'mainCalculator',
        // },
        {
          name: 'เงื่อนไข',
          route: 'condition',
        },
      ]

      return this.filterTabConfig(tabList)

      // switch (pathName) {
      //   // case "calculator":
      //   case 'all-coupon':
      //   case 'my-coupon':
      //   case 'use-coupon': {
      //     tabList = [
      //       // {
      //       //   name: "คำนวณ",
      //       //   route: "calculator",
      //       // },
      //       {
      //         name: 'คูปอง',
      //         route: 'all-coupon',
      //       },
      //       {
      //         name: 'คูปองของฉัน',
      //         route: 'my-coupon',
      //       },
      //     ]
      //     return this.filterTabConfig(tabList)
      //   }
      //   default: {
      //     if (saleType !== '') {
      //       switch (saleType.toLowerCase()) {
      //         case 'wholesale': {
      //           // const index = tabList.findIndex((i) => i.route === "condition");
      //           // tabList[index].name = "สรุปผล";
      //           return this.filterTabConfig(tabList)
      //         }
      //         default:
      //           return this.filterTabConfig(tabList)
      //       }
      //     } else {
      //       return this.filterTabConfig(tabList)
      //     }
      //   }
      // }
    },
  },
  methods: {
    updateScrollIndicator() {
      const nav = this.$refs.tabNav
      if (!nav) return
      const remaining = nav.scrollWidth - nav.clientWidth - nav.scrollLeft
      this.showRightIndicator = remaining > 4
    },
    filterTabConfig(list) {
      const { user_data } = this.$store.state
      return list.filter(
        (e) =>
          // check hide config
          isPassedConditions({
            configName: `tab_${e.route}_hide`,
            configData: user_data.ui_configs,
            targetData: user_data,
          }) != '1'
      )
    },
    active(r) {
      const { name } = this.$route
      if (
        r === name ||
        (name === 'use-coupon' && r === 'my-coupon') ||
        (name === 'ai-shelf-history' && r === 'ai-shelf') ||
        (name === 'ai-shelf-upload' && r === 'ai-shelf')
      ) {
        return 'active'
      }
      return ''
    },
    setActive(routeName) {
      const { name } = this.$route
      window.scrollTo(0, 0)
      if (name !== routeName) {
        let elmActive = document.getElementById(name)
        if (
          name !== 'use-coupon' ||
          name !== 'ai-shelf-history' ||
          name !== 'ai-shelf-upload'
        ) {
          try {
            elmActive?.classList.remove('active')
          } catch (err) {
            console.log(err)
          }
        }
        const elm = document.getElementById(routeName)
        elm?.classList.add('active')
        this.$router.push({ name: routeName })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateScrollIndicator()
      window.addEventListener('resize', this.updateScrollIndicator)
    })
  },
  updated() {
    this.$nextTick(() => {
      this.updateScrollIndicator()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollIndicator)
  },
}
</script>

<style lang="scss" scoped>
$light-blue: #f0f6ff;
$indicator-width: 42px;

.nav-wrap {
  position: relative;
}

nav {
  background: $light-blue;
  border: 1px solid transparent;
  font-size: 14px;
  display: flex;
  gap: 16px;
  padding: 0 16px;
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

nav::-webkit-scrollbar {
  display: none;
}

nav .nav-link {
  align-items: center;
  border-bottom: 5px solid $light-blue;
  display: flex;
  justify-content: center;
  flex: 1 1 0 !important;
  height: 50px;
  padding: 0.2rem 0 !important;
  white-space: nowrap;
  color: #B3B7BD;
}

nav .nav-link.active {
  background: $light-blue;
  font-weight: 700;
  color: inherit;
}

.nav-more-indicator {
  position: absolute;
  top: 0;
  right: 0;
  width: $indicator-width;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5f6470;
  pointer-events: none;
  background: linear-gradient(to right, rgba(240, 246, 255, 0), rgba(240, 246, 255, 0.95) 45%, rgba(240, 246, 255, 1) 100%);
}
</style>
